// Activities data
export const activitiesData = [
  {
    id: 1,
    title: "Bachelor of Arts in Business Education",
    type: 'education',
    companyId: 5,
    startDate: '2016-10-01',
    endDate: '2018-09-30',
    gpa: "none",
    description: "Specialized in basic economics, business administration, leadership and management and production planning and control."
  },
  {
    id: 2,
    title: "Mechatronics Technician",
    type: 'education',
    companyId: 3,
    department: "SIEMENS Professional Education – IHK",
    startDate: '2018-09-01',
    endDate: '2022-02-28',
    gpa: "2.0",
    description: "IHK Apprenticeship in Mechatronics as part of the dual study at SIEMENS AG."
  },
  {
    id: 3,
    title: "B.Eng. – Mechatronics",
    type: 'education',
    companyId: 4,
    department: "Technical Faculty",
    position: "Bachelor Student",
    startDate: '2018-10-01',
    endDate: '2022-09-30',
    degree: "B.Eng.",
    gpa: "1.7",
    description: "Engineering Bachelor in Mechatronics as part of the dual study at SIEMENS AG. Maintained a strong focus on IT within the mechatronics disciplines."
  },
  {
    id: 4,
    title: "Mechatronics Apprentice",
    type: 'work',
    companyId: 3,
    department: "Innovation Lab",
    position: "Mechatronics Apprentice",
    startDate: '2018-09-01',
    endDate: '2022-02-28',
    description: "Contributed to factory automation initiatives, focusing on robotics and industrial programming during dual-study placements."
  },
  {
    id: 5,
    title: "Mechatronics Engineer for IT-Projects",
    type: 'work',
    companyId: 3,
    department: "Projects & Processes",
    position: "Mechatronics Engineer for IT-Projects",
    startDate: '2022-03-01',
    endDate: '2022-09-30',
    description: "Developed real-time data transparency applications using WPF Framework (C#, XAML, SQL), improving assembly line worker efficiency by providing actionable insights."
  },
  {
    id: 6,
    title: "IT & Automation Engineer",
    type: 'work',
    companyId: 1, // Mercedes-Benz as assignment company
    tempAgencyId: 2, // FERCHAU as temporary employment agency
    department: "IT Van",
    position: "IT & Automation Engineer",
    startDate: '2022-10-01',
    endDate: '2024-04-30',
    description: "Led Field Quality Use Case, integrating 12 data sources to accelerate vehicle issue resolution by 80%. Designed Unity Catalog-based data catalog, ensuring GDPR compliance. Improved IT compliance by 67% via governance initiatives and KPI dashboard for automated transparency."
  },
  {
    id: 7,
    title: "IT System- & Process-Consultant",
    type: 'work',
    companyId: 1,
    department: "IT Van",
    position: "IT System- & Process-Consultant",
    startDate: '2024-05-01',
    endDate: null,
    description: "Architected a 1.4 TB Databricks Lakehouse, migrating 150+ Delta tables from 7 TB legacy warehouse, scaling to 7 TB by 2025. Led 15+ developers across 5 partner companies and 3 internal departments. Achieved 90% runtime reduction, 60% cost savings (€60,000/year), and +90% faster data sharing via Unity Catalog."
  }
];
